import { inject } from "aurelia";
import { IProductsService } from './services/products-service';
import { IAuthService } from '@interfaces/auth-service/auth-service-interface';
import { IGenericListConfig } from '@components/generic-list/interfaces/generic-filtered-interface';
import { toastifyError, toastifySuccess } from '@helpers/toastify';
import { IZeusClient, ZeusClient } from "@services/graphql-service/zeus-client";
import { IRouter } from "@aurelia/router";
import { IDialogService } from "@aurelia/dialog";
import { CreateBrandComponent } from "../brand-guide/components/create-brand/create-brand-component";

@inject(IZeusClient, IAuthService, IProductsService, IRouter, IDialogService)
export class ProductsPage {

  private brandId: string;
  private currentStep: number;

  private config: IGenericListConfig = {
    total: 0,
    tableName: 'products',
    streamName: 'products_stream',
    aggregateName: 'products_aggregate',
    columns: ['id', 'alias', 'type', 'category', 'price', 'salePrice', 'description', 'imageOneId', 'imageTwoId', 'imageThreeId', 'imageFourId', 'created_by', 'created_at', 'updated_at', 'deleted', 'ebookFileId', 'slidesFileId', 'productSquareDisplayFileId', 'productVerticalDisplayFileId'],
    filters: [],
    data: [],
    perPage: 12,
    currentPage: 1,
  }

  constructor(
    private zeusClient: ZeusClient,
    private auth: IAuthService,
    private service: IProductsService,
    private router: IRouter,
    private dialogService: IDialogService
  ) { }

  async attached() {
    const response = await this.zeusClient.chain('query')({
      brands: [
        { limit: 1 },
        {
          id: true,
          currentStep: true
        }
      ]
    })

    if (response?.brands?.length) {
      this.brandId = response?.brands[0]?.id as string;
      this.currentStep = response?.brands[0]?.currentStep;
    }
  }

  private async deleteProduct(productId: string): Promise<void> {
    const { id } = await this.service.deleteProductById(productId);

    if (!id) {
      toastifyError({ message: 'Erro ao excluir produto' });
      return;
    }

    toastifySuccess({ message: 'Produto excluido com sucesso' });
  }

  private async createProduct() {
    if ((this.brandId && this.currentStep < 3) || !this.brandId) {
      await this.dialogService.open({
        component: () => CreateBrandComponent,
        model: {
        },
        lock: false,
        startingZIndex: 100,
      });

      return
    } else {
      this.router.load('product');
    }
  }
}